<div class="box">
  <div class="myForm">
    <div class="card">
      <h4 class="card-header">Import FAQ using HTML Template</h4>
      <div class="card-body scroll">
        <form #faqForm="ngForm">
          <p>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Client</mat-label>
              <mat-select name="client" placeholder="Client" [(ngModel)]="faq.client" required>
                <mat-option *ngFor="let item of clients" [value]="item.id">{{item.dname}}</mat-option>
              </mat-select>
              <mat-error>*Client is required</mat-error>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Device</mat-label>
              <mat-select name="device" placeholder="Device" [(ngModel)]="faq.type" required>
                <mat-option *ngFor="let item of devices" [value]="item.id">{{ item.dname }}</mat-option>
              </mat-select>
              <mat-error>*Device is required</mat-error>
            </mat-form-field>
          </p>
          <p>
            <button class="button" color="primary" type="button" mat-raised-button (click)="fileInput.click()" required>
              <mat-icon>attachment</mat-icon>
              FAQ File*
            </button>
            <input hidden (change)="onFileSelected($event)" #fileInput name="file" type="file"
              accept=".html, .xls, .xlsx" [(ngModel)]="faq.file" #file="ngModel" required />
            <br>
            <span>
              <mat-hint><b>{{ faq.file?.name ? faq.file?.name : "&nbsp;" }}
                  <button color="primary" class="remove" *ngIf="faq.file?.name" mat-button (click)="remove()">
                    <mat-icon>delete_forever</mat-icon>
                  </button>
                </b></mat-hint>
            </span>
          </p>
          <p>
            <button color="primary" class="button btn-spc" [disabled]="!faqForm.valid || faq.file?.name.split('.').pop() != 'html'" (click)="upload( false )"
              mat-raised-button> Preview </button>
          </p>
          <p>
            <button color="primary" class="button" [disabled]="!faqForm.valid || buttonClicked" (click)="upload(true)"
              type="submit" mat-raised-button>
              {{ buttonClicked && status ? "Uploading" : "Upload" }}
              <span>
                <mat-icon *ngIf="buttonClicked && status">
                  <mat-spinner diameter="25"></mat-spinner>
                </mat-icon>
              </span>
            </button>
          </p>
        </form>
      </div>
    </div>
  </div>
</div>